import {
  AdvancedTooltip,
  HighlightedText,
  Text,
  ToggleSwitcher
} from 'common-components'
import * as Styled from './styled'
import { useCallback, useEffect, useState } from 'react'

import { THUNDER_ICON } from 'consts/mediaUrls'
import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { dispatch } from 'store'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { projectStyleSelector } from 'store/selectors'

const StyleConsistencySection: React.FC = () => {
  const projectStyle = useSelector(projectStyleSelector)
  const isConsistencyEnabled = useSelector(
    aiVideoSelectors.isConsistencyEnabled
  )
  const isNoModelSelected = useSelector(aiVideoSelectors.isNoModelSelected)

  const defaultImageModelCost = useSelector(aiImageSelectors.defaultModelCost)
  const [styleImageRef, setStyleImageRef] = useState<HTMLImageElement | null>(
    null
  )

  const toggleConsistency = useCallback(() => {
    dispatch(aiVideoThunks.setIsConsistencyEnabled(!isConsistencyEnabled))
  }, [isConsistencyEnabled])

  useEffect(() => {
    if (isConsistencyEnabled) {
      dispatch(aiVideoThunks.resetReferenceImagesAndTargetData())
    }
  }, [isConsistencyEnabled])

  if (!projectStyle) {
    return null
  }

  const { thumbnailUrl, name } = projectStyle

  return (
    <Styled.StyleConsistencySection>
      <Styled.TitleWrapper>
        <Text type="h2" fontWeight="600" color="secondaryDark">
          {translate(T.SMART_PROJECT_MATCH)}
        </Text>
        <Styled.ThunderIconWrapper>
          <Styled.ThunderIcon src={THUNDER_ICON} alt="credits icon" />
          <Text type="h4" color="secondary">
            {defaultImageModelCost}
          </Text>
        </Styled.ThunderIconWrapper>
      </Styled.TitleWrapper>
      <Styled.StyleConsistencyContainer>
        {thumbnailUrl && (
          <Styled.StyleImage src={thumbnailUrl} ref={setStyleImageRef} />
        )}
        <AdvancedTooltip
          tooltipText={name}
          tooltipPosition="top"
          btnRef={{ current: styleImageRef }}
          showMobileTooltip
        />
        <Styled.TextContentWrapper>
          <Text type="h4" color="secondarySemiDark">
            <HighlightedText
              text={translate(T.SMART_PROJECT_MATCH_DESCRIPTION)}
              elementType="span"
              attributes={{
                className: 'highlighted'
              }}
            />
          </Text>
        </Styled.TextContentWrapper>
        <ToggleSwitcher
          isChecked={isConsistencyEnabled}
          onChange={toggleConsistency}
          isDisabled={isNoModelSelected}
        />
      </Styled.StyleConsistencyContainer>
    </Styled.StyleConsistencySection>
  )
}

export default StyleConsistencySection
